export default __webpack_public_path__ + "3kQbXv9-warning.svg";